// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","name":"name-397Vh","flight_direction":"flight_direction-2Na1T","flight_count":"flight_count-1OQc3","flight_icon":"flight_icon-34FtI"};